import { render } from "./TransferCertificate.vue?vue&type=template&id=49d8a63c&scoped=true"
import script from "./TransferCertificate.vue?vue&type=script&lang=js"
export * from "./TransferCertificate.vue?vue&type=script&lang=js"

import "./TransferCertificate.vue?vue&type=style&index=0&id=49d8a63c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49d8a63c"]])

export default __exports__